export default {
  name: 'EmptyList',
  props: {
    headerText: {
      type: String,
      require: true,
    },
    descriptionText: {
      type: String,
      require: true,
    },
    buttonText: {
      type: String,
      require: true,
    },
    hasButton: {
      type: Boolean,
      default: true,
    },
  },
};
